//本地导入
import request from "../request";

//亲密度-列表
export const intimacyList = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/intimacy/list",
  });

//亲密度-明细
export const intimacyLogList = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/intimacy/log/list",
  });
